var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M15.4,8h3.3c0.3,0,1,0.1,1,0.5v1.8h-1.9l2.5,2.5l2.5-2.5h-1.5V8.5c0-1.2-1.1-2.1-2.6-2.1h-3.3 c-0.2,0-0.4,0.2-0.4,0.4v0.8C15,7.8,15.2,8,15.4,8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.4,14H10.2c-0.6,0-1,0.4-1,1v10c0,0.6,0.4,1,1,1h15.2c0.6,0,1-0.4,1-1V15C26.4,14.4,26,14,25.4,14z M24.7,17.6l-9.6,0 l0-2h9.6V17.6z M13.4,15.7l0,2l-2.6,0v-2H13.4z M10.8,19.4l2.6,0l0,5h-2.6V19.4z M15.1,24.3l0-5l9.6,0v5H15.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.9,0H1C0.4,0,0,0.4,0,1v9.2c0,0.6,0.4,1,1,1h11.9c0.6,0,1-0.4,1-1V1C13.9,0.4,13.4,0,12.9,0z M12.2,5.5l-2.4,0l0-2.3 l2.4,0V5.5z M5.8,5.5l0-2.3l2.3,0l0,2.3L5.8,5.5z M8.1,7.2l0,2.4H5.8l0-2.4L8.1,7.2z M1.7,3.2l2.4,0l0,2.3l-2.5,0V3.2z M1.7,7.2 l2.5,0l0,2.3H1.7V7.2z M9.8,9.6l0-2.4l2.4,0v2.4H9.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvListView);
export default __webpack_public_path__ + "static/media/AdvListView.6bafd946c94f4cc555b084986dfc9611.svg";
export { ForwardRef as ReactComponent };